import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./features/homepage/HomePage";
import DealerContainer from "./features/dealer/DealerContainer";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./utility/authConfig";
import NavBar from "./features/navigation/NavBar";
import AuditPage from "./features/license-audit/AuditPage";
import InactiveDealersPage from "./features/dealer-list/InactiveDealersPage";
import KenectPage from "./features/kenect/KenectPage";
import NewCustomerForm from "./Forms/NewCustomerForm";

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dealer/:accountNumber" element={<DealerContainer />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/inactive" element={<InactiveDealersPage />} />
          <Route path="/kenect" element={<KenectPage />} />
          <Route path="/newcustomer" element={<NewCustomerForm />} />
        </Routes>
      </BrowserRouter>
    </MsalProvider>
  );
}

export default App;
